import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

/* replace-start */
import './index.less';
/* replace-end */
class Feature21 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.children;
      const titleLists = (title) => {
        return title.children.map((item, index) => {
          return (
            <div {...item} key={item.children + index}>
              <span dangerouslySetInnerHTML={{ __html: item.children }} />
            </div>
          );
        });
      };

      return itemLists.map((key, index) => {
        const { title, img, icon, ...other } = key;
        return (
          <div {...other} key={title.children + index}>
            <div {...img}>
              <img src={img.children} alt="" />
            </div>
            <div className="row">
              <div {...icon}>
                <img src={icon.children} alt="" />
              </div>
              {titleLists(title)}
              {/* <div {...title}>
                <span dangerouslySetInnerHTML={{ __html: title.children }} />
              </div> */}
            </div>
          </div>
        );
      }
      );
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <TweenOne
          animation={{
            x: 0,
            duration: 1000,
          }}
          style={{ transform: 'translateX(80px)' }}
          {...dataSource.content}
        >
          {getItem()}
        </TweenOne>
        <TweenOne
          animation={{
            x: 0,
            duration: 1000,
          }}
          style={{ transform: 'translateX(-80px)' }}
          {...dataSource.title}
        >
          <div {...dataSource.title.main}>
            <span dangerouslySetInnerHTML={{ __html: dataSource.title.main.children }} />
          </div>
          <div {...dataSource.title.second}>
            <span dangerouslySetInnerHTML={{ __html: dataSource.title.second.children }} />
          </div>
        </TweenOne>
      </OverPack>
    );
  }
}
export default Feature21;
